import React from 'react'
import ContactUs from "../../Contact/ContactUs";
import Footer from "../../Footer/Footer";
export const ContactUsPDF = () => {
  return (
    <div className="py-20 relative " style={{ height: "100vh" }}>
        <div className="px-20 pt-10 flex justify-center">
          <ContactUs contact="pdf" />
        </div>
        <div
          className=" absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"
          style={{ backgroundColor: "#e2e8f0" }}
        >
          <Footer footer="pdf" />
        </div>
      </div>
  )
}
